import React, { Suspense, useEffect, useState } from 'react';
import ReactDom from 'react-dom';
import { Spin } from 'antd';
import { initializeAuth, startTokenRefreshTimer } from './utils/auth';
import { getParentSearchParamsSafe } from '@/common/utils';
import { isMainIframe } from './common/isMainIframe';
// import'./routes/VipDialog/AdvertVipPayment/AdvertPurchaseDialog'

// 早期环境检查与重定向
const checkAndRedirectBeta = () => {
    const sp = getParentSearchParamsSafe();
    const state = sp.get('state');
    if (state === 'beta') {
        const currentHostname = window.location.hostname;
        if (currentHostname !== 'beta.kuguanggao.com') {
            const newUrl = window.location.href.replace(currentHostname, 'beta.kuguanggao.com');
            window.location.replace(newUrl);
            return true; // 表示正在重定向
        }
    }
    return false;
};

const isRedirecting = checkAndRedirectBeta();

const App = React.lazy(() => import('./app'));

// 认证包装器组件
function AuthWrapper({ children }: { children: React.ReactNode }) {
    const [authState, setAuthState] = useState<'loading' | 'authenticated' | 'unauthenticated'>('loading');

    useEffect(() => {
        // 非主 Iframe 不走认证，直接放行
        if (!isMainIframe) {
            setAuthState('authenticated');
            return;
        }

        // 初始化认证
        initializeAuth()
            .then((success) => {
                if (success) {
                    setAuthState('authenticated');
                    // 启动自动刷新定时器
                    const timer = startTokenRefreshTimer();
                    // 清理定时器
                    return () => clearInterval(timer);
                } else {
                    setAuthState('unauthenticated');
                    console.warn('Authentication failed. Please provide OAuth code or re-authenticate.');
                }
            })
            .catch((error) => {
                console.error('Auth initialization error:', error);
                setAuthState('unauthenticated');
            });
    }, []);

    // 显示加载状态
    if (authState === 'loading') {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    width: '100vw',
                }}
            >
                <Spin size="large" tip="正在初始化认证..." />
            </div>
        );
    }

    // 未认证状态 - 显示提示信息
    if (authState === 'unauthenticated') {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    width: '100vw',
                    flexDirection: 'column',
                    gap: '16px',
                }}
            >
                <div>认证失败，请重新登录</div>
                <div style={{ fontSize: '12px', color: '#999' }}>
                    请通过 OAuth 认证后访问
                </div>
            </div>
        );
    }

    // 已认证 - 渲染子组件
    return <>{children}</>;
}

function Entry() {
    if (isRedirecting) {
        return null;
    }
    return (
        <AuthWrapper>
            <Suspense fallback={<Spin size="large" tip="正在加载..." />}>
                <App />
            </Suspense>
        </AuthWrapper>
    );
}

ReactDom.render(<Entry />, document.querySelector('#root'));
